import { es as asm } from "./asm/index";
import { es as importExport } from "./cart/import-export/index"
import { es as cdc} from "./cdc/index";
import { es as order } from "./order/order/index"
import { es as orderApproval } from "./order/order-approval/index"
import { es as savedCart } from "./cart/saved-cart/index"
import { es as base } from "./cart/base/index"
import { es as wishList } from "./cart/wish-list/index"
import { es as quickOrder } from "./cart/quick-order/index"
import { es as s4om } from "./s4om/index"
import { es as baseCheckout } from "./checkout/base/index"
import { es as b2b } from "./checkout/b2b/index"
import { es as scheduled } from "./checkout/scheduled/index"
import { es as customerTicketing } from "./customer-ticketing/index"
import { es as digitalPayments } from "./digital-payments/index"
import { es as epdVisualization } from "./epd-visualization/index"
import { es as pdfInvoices } from "./pdf-invoices/index"
import { es as accountSummary } from "./organization/account-summary/index"
import { es as unitOrder } from "./organization/unit-order/index"
import { es as administration } from "./organization/administration/index"
import { es as userRegistration } from "./organization/user-registration/index"
import { es as pickupInStore } from "./pickup-in-store/index"
import { es as bulkPricing } from "./product/bulk-pricing/index"
import { es as imageZoom } from "./product/image-zoom/index"
import { es as futureStock } from "./product/future-stock/index"
import { es as variants } from "./product/variants/index"
import { es as productConfigurator } from "./product-configurator/index"
import { es as requestedDeliveryDate } from "./requested-delivery-date/index"
import { es as storefinder } from "./storefinder/index"
import { es as account } from "./user/account/index"
import { es as profile } from "./user/profile/index"
import { es as projects } from "./projects/index"
import { es as quote } from "./quote/index"
import { es as gonvarri } from "./gonvarri/index"
import { es as data } from "./client-program/index"
import { es as textTubes} from "./quick-stock/index";
import { es as quickStock } from "./quickStock/index";
import { es as product } from "./product/product-grid/index"
import { es as ticket } from "./ticket/index"

export const es = {
  ...asm,
  ...importExport,
  ...cdc,
  ...order,
  ...orderApproval,
  ...savedCart,
  ...base,
  ...wishList,
  ...quickOrder,
  ...s4om,
  ...baseCheckout,
  ...b2b,
  ...scheduled,
  ...customerTicketing,
  ...digitalPayments,
  ...epdVisualization,
  ...pdfInvoices,
  ...accountSummary,
  ...unitOrder,
  ...administration,
  ...userRegistration,
  ...pickupInStore,
  ...bulkPricing,
  ...imageZoom,
  ...futureStock,
  ...variants,
  ...productConfigurator,
  ...requestedDeliveryDate,
  ...storefinder,
  ...account,
  ...profile,
  ...projects,
  ...quote,
  ...gonvarri,
  ...data,
  ...textTubes,
  ...quickStock,
  ...product,
  ...ticket
}
